import {produce} from 'immer';

import {exhaustiveCheck} from 'web-app/util/typescript';

import {type Action, type State} from './types';

export const reducer: (state: State, action: Action) => State = produce((state, action) => {
    switch (action.type) {
        case 'SET_DATE_RANGE': {
            state.dateRange = action.payload.dateRange;
            if (state.dateRange.toExclusive) {
                state.continuePlan = true;
            }
            break;
        }
        case 'SET_CONTINUE_PLAN':
            state.continuePlan = action.payload.continuePlan;
            break;
        case 'UPDATE_PLAN_VALIDATION_ERRORS': {
            state.validationErrors = action.payload.validationErrors;
            break;
        }
        default:
            exhaustiveCheck(action);
            break;
    }
});
